import async from 'async'
import React from 'react'
import app from '../../../app.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import { ReportList } from '../../report/report_list'
import { ReportsIcon } from '../../../common/layout/menu_icons/reports.jsx'

class PageReport extends PageBase {
  constructor (props) {
    super(props, 'report', 'report', 'report')

    this.state = {
      isLoading: true,
      dataDate: null,
      report: null
    }

    this.data = {
      reports: []
    }

    this._references = {
      reportExportDialog: React.createRef()
    }

    this._setFABButtonState(false, false)
    this._bUnMounted = false
  }

  componentDidMount () {
    this._getData()
    this._initEvents()
  }

  componentWillUnmount () {
    this._bUnMounted = true
    this._releaseEvents()
  }

  renderContent () {
    return (
      <div className='pageinnercont'>
        {!this.state.isLoading && !this.data.reports.length
          ? <ContentMessage message='report.list.msgNoReport' />
          : <ReportList reports={this.data.reports} />}
      </div>
    )
  }

  _onClickExport (fileType, e) {
    e.preventDefault()

    const params = {
      query: {
        clientTimezoneOffset: DateUtil.getLocalTimezoneOffset(),
        $client: { ident: this.state.report.ident, filterData: {} }
      }
    }

    this._processFilterDate(params)

    const data = {
      viewIdent: this.state.report.ident,
      fileType: fileType
    }

    app
      .service('/api/report/export')
      .create(data, params)
      .then((result) => {
        app.redirect(
          `/export/${app.getTeamId()}/report-${this.state.report.ident}/${
            result.fileType
          }/${result.fileName}`
        )
      })
      .catch((err) => {
        app.debug('PageReportView: onClickExport error', err)
      })
  }

  _getData () {
    async.series(
      [
        (done) => {
          this._getPageData(done)
        },
        (done) => {
          this._getDataReport(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _getDataReport (callback) {
    app.debug('PageReport: _getDataReport [start]')
    const params = {
      query: {
        $limit: 20,
        ident: { $ne: 'planner-overview' }
      }
    }

    app
      .service('/api/report')
      .find(params)
      .then((result) => {
        this.data.reports = result.data
        callback(null)
      })
      .catch((err) => {
        app.debug('PageReport: getDataReport err', err)
        callback(err)
      })
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageReport: _onDataReceived Error', err)
    } else {
      app.debug('PageReport: _onDataReceived [done]')
    }
    this.setState({ isLoading: false, dataDate: new Date() })
  }

  _processFilterDate (params) {
    const date = DateUtil.getUTCCurrentDate()
    const currYear = DateUtil.getLocalYear()
    const currMonth = DateUtil.getLocalMonth()
    const currDay = date.getDate()

    if (this.state.report.ident === 'work-in-progress') {
      const currDate = DateUtil.getUTCDate(currYear, currMonth, currDay)
      const filterDate = new Date(currDate)
      filterDate.setHours(23, 59, 59, 0)
      params.query.$client.filterData.date = filterDate
    } else if (this.state.report.ident === 'employee-productivity-v2') {
      params.query.$client.filterData.fromDate = DateUtil.getUTCDate(
        currYear,
        currMonth,
        1
      )
      params.query.$client.filterData.toDate = DateUtil.getUTCDate(
        currYear,
        currMonth + 1,
        1
      )
    } else {
      params.query.$client.filterData.from = DateUtil.getUTCDate(
        currYear,
        currMonth,
        1
      )
      params.query.$client.filterData.to = DateUtil.getUTCDate(
        currYear,
        currMonth + 1,
        1
      )
    }
  }

  _initEvents () {
    this._eventHandlers.reportCreated = this._eventReload.bind(
      this,
      'Report',
      'Created'
    )
    this._eventHandlers.reportUpdated = this._eventReload.bind(
      this,
      'Report',
      'Updated'
    )
    this._eventHandlers.reportRemoved = this._eventReload.bind(
      this,
      'Report',
      'Removed'
    )
    this._eventHandlers.reportPatched = this._eventReload.bind(
      this,
      'Report',
      'Patched'
    )

    const reportService = app.service('/api/report')
    reportService.on('created', this._eventHandlers.reportCreated)
    reportService.on('updated', this._eventHandlers.reportUpdated)
    reportService.on('removed', this._eventHandlers.reportRemoved)
    reportService.on('patched', this._eventHandlers.reportPatched)
  }

  _releaseEvents () {
    const reportService = app.service('/api/report')
    reportService.off('created', this._eventHandlers.reportCreated)
    reportService.off('updated', this._eventHandlers.reportUpdated)
    reportService.off('removed', this._eventHandlers.reportRemoved)
    reportService.off('patched', this._eventHandlers.reportPatched)

    this._eventHandlers.reportService = null
    this._eventHandlers.reportService = null
    this._eventHandlers.reportService = null
    this._eventHandlers.reportService = null
  }

  _eventReload (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PageReport - ${objectName} - ${eventName} --`)
      this._reloadData()
    }
  }

  renderHeader () {
    return (
      <PageHeader
        title='report.list.title'
        icon={<ReportsIcon width={25} />}
      />
    )
  }
}

export default PageReport
